module.exports = __webpack_public_path__ + "static/cooking-app-cover-1bb584d29b43b414394fc0d13985597f.png";